import { Component, OnInit } from '@angular/core';
import {ConfigurationService} from '../configuration.service';
import {TreatmentService} from '../../../services/treatment.service';
import {TreatmentEndoAutofillItemModel} from '../../treatment/models/configuration/treatment-endo-autofill-item.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {TreatmentEndoCanalEnumService} from '../../treatment/treatment-endo-canal-enum.service';

@Component({
  selector: 'app-treatment-configuration',
  templateUrl: './treatment-configuration.component.html',
  styleUrls: ['./treatment-configuration.component.css']
})
export class TreatmentConfigurationComponent implements OnInit {
  isLoading: boolean = true;

  configInfo: TreatmentEndoAutofillItemModel[];
  selectedConfig: TreatmentEndoAutofillItemModel;

  pulpStatusEnums: EnumValidValueItemModel[];
  ewlEnums: EnumValidValueItemModel[];
  referenceEnums: EnumValidValueItemModel[];
  awlEnums: EnumValidValueItemModel[];
  apicalCurvatureEnums: EnumValidValueItemModel[];
  apicalCurvature1LocEnums: EnumValidValueItemModel[];
  apicalCurvature2LocEnums: EnumValidValueItemModel[];
  ffbEnums: EnumValidValueItemModel[];
  mafEnums: EnumValidValueItemModel[];
  gpSizeEnums: EnumValidValueItemModel[];
  sealerEnums: EnumValidValueItemModel[];
  fillEnums: EnumValidValueItemModel[];
  moEnums: EnumValidValueItemModel[];
  iamEnums: EnumValidValueItemModel[];
  coronalEndo1Enums: EnumValidValueItemModel[];
  coronalEndo2Enums: EnumValidValueItemModel[];
  coronalEndoPostSpaceEnums: EnumValidValueItemModel[];

  constructor(private treatmentService: TreatmentService,
              public canalEnumService: TreatmentEndoCanalEnumService,
              public configurationService: ConfigurationService,
              private staticDataService: StaticDataService) { }

  ngOnInit(): void {
    this.treatmentService.getTreatmentAutoFillConfigurationModels().subscribe((res) => {
      this.configInfo = res;
      this.configInfo = this.configInfo.sort((a, b) => {
        return parseInt(a.AutoFillName) - parseInt(b.AutoFillName);
      });
      this.selectedConfig = this.configInfo[0];

      if (this.staticDataService.isReady) {
        this.setEnums();
      } else {
        this.staticDataService.validValuesReadyEvent.subscribe({
          complete: () => {
            this.setEnums();
          }
        });
      }
    });
  }

  private setEnums() {
    this.pulpStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPulpStatus');
    this.ewlEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoEstimatedWorkLength');
    this.referenceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoReference');
    this.awlEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoActualWorkLength');
    this.apicalCurvatureEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoApicalCurv');
    this.apicalCurvature1LocEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoApicalCurv1Loc');
    this.apicalCurvature2LocEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoApicalCurv2Loc');
    this.ffbEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFirstFile2Bind');
    this.mafEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoMasterApicalFile');
    this.gpSizeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoGuttaPercha');
    this.sealerEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoSealer');
    this.fillEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFill');
    this.moEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoMethodOfObturation');
    this.iamEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoInterAptMed');
    this.coronalEndo1Enums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoCoronal1Type');
    this.coronalEndo2Enums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoCoronal2Type');
    this.coronalEndoPostSpaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoCoronalPostSpace');
    console.log('status');
    this.isLoading = false;
  }

  onConfigItemClick(model: TreatmentEndoAutofillItemModel) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectedConfig = model;
          return;
        } else {

        }
      });
    } else {
      this.selectedConfig = model;
    }
  }

  isSelectedModel(model: TreatmentEndoAutofillItemModel) {
    return this.selectedConfig === model;
  }

  save() {
    this.treatmentService.saveTreatmentAutoFillConfiguration(this.configInfo).subscribe((res) => {
      //
      this.configurationService.setClean();
    });
  }

  getEnumById(enumId: string, enums: EnumValidValueItemModel[]) {
    if (!enums) {
      return null;
    }
    const enu = enums.find(p => p.ValidValueItemId === enumId);
    if (enu) {
      return enu;
    } else {
      return null;
    }
  }
}
